import { useContext } from 'react';

import { invariant } from '@e-socna/utils';

import { MissionContext } from '../index';

export const useMissionContext = () => {
  const context = useContext(MissionContext);

  invariant(
    !!context,
    'useMissionContext must be used within a MissionContextProvider',
  );

  return context;
};
